import { AddToList } from 'education-icons';
import { Button, Link, SimpleText, useAppContext, useGeneratePath, useStaticUrls } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    canCreateProblems: boolean;
}

export const SidePanelControlsTypeCreateProblem = React.memo((props: Props) => {
    const { notifyCanBeRender, notifyCanNotBeRender, canCreateProblems } = props;
    const { prefix, basePath } = useAppContext();
    const { cmCourseLessonProblemNew } = useStaticUrls();
    const clessonId = useSelector(lessonSelectors.getCLessonId) || 0;
    const courseId = useSelector(getCurrentYearCourseId) || 0;
    const getRouterPath = useGeneratePath();

    // clessonId может не быть (в библиотеке), но мы не можем вызывать useRouterPath после early return-а
    if (!canCreateProblems || clessonId === 0 || courseId === 0) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    const createProblem = () => {
        const path = getRouterPath(cmCourseLessonProblemNew, { clessonId, courseId });
        window.location.href = `${basePath}${prefix}${path}`;
    };

    return (
        <Link mix="qa_create-problem" onClick={createProblem} pseudo>
            <Button accent={Button.ACCENT.NORMAL} icon={<AddToList />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonEditor.createProblem" />
            </Button>
        </Link>
    );
});
